/*
 * サブシステム名：
 * 機能名：受注・実績一覧
 * 表示項目カスタマイズ(石橋梱包運輸)
 */
import D2PRMD0010 from '@/views/PRM/D2PRMD0010.js'
import filter from '@/rahmen/utils/filters'

export default {
  extends: D2PRMD0010,
  name: 'HaisoMeisaiListCustomForIshibashi',
  data: () => ({
    custoMizeHeaders: [
      { text: '運行日', value: 'unkoYmdDisp' },
      { text: '乗務員', value: 'jomuinDisp' },
      { text: '車両番号', value: 'sharyoDisp' },
      { text: '発地', value: 'hatsuchiDisp' },
      { text: '着地', value: 'chakuchiDisp' },
      { text: '請求計上日', value: 'seikyuYoteiYmdDisp' },
      { text: '請求車種', value: 'seikyuShashuSbtNm' },
      { text: '売上課税', value: 'kihonUnchinDisp', align: 'end' },
      { text: '売上非課税', value: 'unchinHokaHikazeiDisp', align: 'end' },
      { text: '件数割増', value: 'unchinHokaKingakuDisp', align: 'end' },
      { text: '他割増', value: 'warimashiSonotaKingakuDisp', align: 'end' },
      { text: '運賃(高速)', value: 'hiwayPriceDisp', align: 'end' },
      { text: '摘要', value: 'seikyuBiko' },
      { text: '傭車額', value: 'yoshaKihonUnchinDisp', align: 'end' },
      { text: '傭車通行料', value: 'yoshaHiwayPriceDisp', align: 'end' },
      { text: '得意先', value: 'tokuisakiDisp' },
      { text: '傭車先', value: 'hacchusakiDisp' },
      { text: '運行実績No', value: 'unkoJissekiNo' },
      { text: '受注No', value: 'juchuNo' },
      { text: '配送明細No', value: 'meisaiOrder' },
      { text: '配車確定済', value: 'keikakuKakuteiFlgDisp', align: 'center' },
      { text: '実績登録済', value: 'jissekiTorokuKbnDisp', align: 'center' },
      { text: '実績確認済', value: 'jissekiKakuninZumiFlgDisp', align: 'center' },
      { text: '配車営業所', value: 'haishaEigyoshoDisp' },
      { text: '配車先区分', value: 'haishasakiNm' },
      { text: '配車担当者', value: 'haishaTantoshaDisp' },
      { text: '同乗者', value: 'dojoshaDisp' },
      { text: '受注営業所', value: 'juchuEigyoshoDisp' },
      { text: '注文番号', value: 'chumonNo' },
      { text: 'コース名', value: 'courseNm' },
      { text: '往復種別', value: 'ohfukuSbtNm' },
      { text: '運賃確定済み', value: 'unchinKakuteiFlgDisp', align: 'center' },
      { text: '請求止め対象', value: 'seikyuTomeFlgDisp', align: 'center' },
      { text: '発地年月日', value: 'hatsuchiYmdDisp' },
      { text: '発地時刻', value: 'hatsuchiHmsDisp' },
      { text: '経由地１', value: 'keiyuchi1Disp' },
      { text: '経由地２', value: 'keiyuchi2Disp' },
      { text: '経由地３', value: 'keiyuchi3Disp' },
      { text: '経由地４', value: 'keiyuchi4Disp' },
      { text: '経由地５', value: 'keiyuchi5Disp' },
      { text: '着地年月日', value: 'chakuchiYmdDisp' },
      { text: '着地時刻', value: 'chakuchiHmsDisp' },
      { text: '品名', value: 'hinmeiDisp' },
      { text: '数量', value: 'juchuSuryoDisp', align: 'end' },
      { text: '単位', value: 'unitKbnNm' },
      { text: '重量(t)', value: 'juchuJuryoDisp', align: 'end' },
      { text: '単価', value: 'tankaDisp' },
      { text: '運賃計算区分', value: 'unchinKeisanKbnNm' },
      { text: '保管料', value: 'hokanKingakuDisp', align: 'end' },
      { text: '荷役量', value: 'niekiKingakuDisp', align: 'end' },
      { text: '立替金(非)', value: 'tatekaekinHikazeiDisp', align: 'end' },
      { text: '割増金額(時間)', value: 'jikanWarimashiKingakuDisp', align: 'end' },
      { text: '割増金額(距離)', value: 'kyoriWarimashiKingakuDisp', align: 'end' },
      { text: '運行手当', value: 'sagyoinTeateKingaku1Disp', align: 'end' },
      { text: '高速ETC', value: 'sharyoKeihiHiwayEtcDisp', align: 'end' },
      { text: '高速現金', value: 'sharyoKeihiHiwayGenkinDisp', align: 'end' },
      { text: 'フェリー', value: 'sharyoKeihiFerryDisp', align: 'end' },
      { text: '社内傭車額', value: 'sharyoKeihiEtc1Disp', align: 'end' }
    ]
  }),
  computed: {
    custoMizeFilteredRows () {
      console.log('filter', this.rows)
      return this.rows.map((elem) => {
        elem.juchuJissekiId = String(elem.keikakujissekikey) + String(elem.juchuNo)
        elem.unkoYmdDisp = elem.unkoYmd ? filter.dateFormatter(elem.unkoYmd) : ''
        elem.keikakuKakuteiFlgDisp = elem.keikakuKakuteiFlg ? '〇' : ''
        elem.jissekiTorokuKbnDisp = elem.trUnkoJissekiId > 0 ? '〇' : ''
        elem.jissekiKakuninZumiFlgDisp = elem.jissekiKakuninZumiFlg ? '〇' : ''
        elem.haishaEigyoshoDisp = elem.haishaEigyoshoCd ? elem.haishaEigyoshoCd + ' : ' + elem.haishaEigyoshoNm : ''
        elem.haishaTantoshaDisp = elem.haishaTantoJininCd ? elem.haishaTantoJininCd + ' : ' + elem.haishaTantoJininNm : ''
        elem.hacchusakiDisp = elem.hacchusakiCd ? elem.hacchusakiCd + ' : ' + elem.hacchusakiNm : ''
        elem.sharyoDisp = elem.haishaKbn === '03' ? elem.torokuNo : elem.jidoshaHyojiNm
        elem.jomuinDisp = elem.jomuinJininCd ? elem.jomuinJininCd + ' : ' + elem.jomuinJininNmSei : ''
        elem.dojoshaDisp = elem.joshuJininCd ? elem.joshuJininCd + ' : ' + elem.joshuJininNmSei : ''
        elem.juchuEigyoshoDisp = elem.juchuEigyoshoCd ? elem.juchuEigyoshoCd + ' : ' + elem.juchuEigyoshoNm : ''
        elem.tokuisakiDisp = elem.tokuisakiCd ? elem.tokuisakiCd + ' : ' + elem.tokuisakiNm : ''
        elem.unchinKakuteiFlgDisp = elem.unchinKakuteiFlg ? '〇' : ''
        elem.seikyuTomeFlgDisp = elem.seikyuTomeFlg ? '〇' : ''
        elem.hatsuchiDisp = elem.hatsuchiCd ? elem.hatsuchiCd + ' : ' + elem.hatsuchiNm : elem.hatsuchiBiko
        elem.hatsuchiYmdDisp = elem.hatsuchiYmd ? filter.dateFormatter(elem.hatsuchiYmd) : ''
        elem.hatsuchiHmsDisp = elem.hatsuchiHms ? (elem.hatsuchiHms).slice(0, 5) : ''
        elem.keiyuchi1Disp = elem.keiyuchi1Cd ? elem.keiyuchi1Cd + ' : ' + elem.keiyuchi1Nm : elem.keiyuchiId1Biko
        elem.keiyuchi2Disp = elem.keiyuchi2Cd ? elem.keiyuchi2Cd + ' : ' + elem.keiyuchi2Nm : elem.keiyuchiId2Biko
        elem.keiyuchi3Disp = elem.keiyuchi3Cd ? elem.keiyuchi3Cd + ' : ' + elem.keiyuchi3Nm : elem.keiyuchiId3Biko
        elem.keiyuchi4Disp = elem.keiyuchi4Cd ? elem.keiyuchi4Cd + ' : ' + elem.keiyuchi4Nm : elem.keiyuchiId4Biko
        elem.keiyuchi5Disp = elem.keiyuchi5Cd ? elem.keiyuchi5Cd + ' : ' + elem.keiyuchi5Nm : elem.keiyuchiId5Biko
        elem.chakuchiDisp = elem.chakuchiCd ? elem.chakuchiCd + ' : ' + elem.chakuchiNm : elem.chakuchiBiko
        elem.chakuchiYmdDisp = elem.chakuchiYmd ? filter.dateFormatter(elem.chakuchiYmd) : ''
        elem.chakuchiHmsDisp = elem.chakuchiHms ? (elem.chakuchiHms).slice(0, 5) : ''
        elem.hinmeiDisp = elem.hinmeiCd ? elem.hinmeiCd + ' : ' + elem.hinmeiNm : elem.hinmeiBiko
        elem.juchuSuryoDisp = elem.juchuSuryo ? filter.numericFormatter(elem.juchuSuryo) : ''
        elem.tankaDisp = elem.tanka ? filter.numericFormatter(elem.tanka) : 0
        elem.juchuJuryoDisp = elem.juchuJuryo ? filter.numericFormatter(elem.juchuJuryo) : ''
        elem.seikyuYoteiYmdDisp = elem.seikyuYoteiYmd ? filter.dateFormatter(elem.seikyuYoteiYmd) : ''
        elem.kihonUnchinDisp = elem.kihonUnchin ? filter.numericFormatter(elem.kihonUnchin) : 0
        elem.hokanKingakuDisp = elem.hokanKingaku ? filter.numericFormatter(elem.hokanKingaku) : 0
        elem.niekiKingakuDisp = elem.niekiKingaku ? filter.numericFormatter(elem.niekiKingaku) : 0
        elem.unchinHokaKingakuDisp = elem.unchinHokaKingaku ? filter.numericFormatter(elem.unchinHokaKingaku) : 0
        elem.hiwayPriceDisp = elem.hiwayPrice ? filter.numericFormatter(elem.hiwayPrice) : 0
        elem.unchinHokaHikazeiDisp = elem.unchinHokaHikazei ? filter.numericFormatter(elem.unchinHokaHikazei) : 0
        elem.tatekaekinHikazeiDisp = elem.tatekaekinHikazei ? filter.numericFormatter(elem.tatekaekinHikazei) : 0
        elem.jikanWarimashiKingakuDisp = elem.jikanWarimashiKingaku ? filter.numericFormatter(elem.jikanWarimashiKingaku) : 0
        elem.kyoriWarimashiKingakuDisp = elem.kyoriWarimashiKingaku ? filter.numericFormatter(elem.kyoriWarimashiKingaku) : 0
        elem.warimashiSonotaKingakuDisp = elem.warimashiSonotaKingsku ? filter.numericFormatter(elem.warimashiSonotaKingsku) : 0
        elem.yoshaKihonUnchinDisp = elem.yoshaKihonUnchin ? filter.numericFormatter(elem.yoshaKihonUnchin) : 0
        elem.yoshaHiwayPriceDisp = elem.yoshaHiwayPrice ? filter.numericFormatter(elem.yoshaHiwayPrice) : 0
        elem.sagyoinTeateKingaku1Disp = elem.sagyoinTeateKingaku1 ? filter.numericFormatter(elem.sagyoinTeateKingaku1) : 0
        elem.sharyoKeihiHiwayEtcDisp = elem.sharyoKeihiHiwayEtc ? filter.numericFormatter(elem.sharyoKeihiHiwayEtc) : 0
        elem.sharyoKeihiHiwayGenkinDisp = elem.sharyoKeihiHiwayGenkin ? filter.numericFormatter(elem.sharyoKeihiHiwayGenkin) : 0
        elem.sharyoKeihiFerryDisp = elem.sharyoKeihiFerry ? filter.numericFormatter(elem.sharyoKeihiFerry) : 0
        elem.sharyoKeihiEtc1Disp = elem.sharyoKeihiEtc1 ? filter.numericFormatter(elem.sharyoKeihiEtc1) : 0
        return elem
      }).sort((a, b) => {
        if (a.meisaiOrder > b.meisaiOrder) { return 1 }
        if (a.meisaiOrder === b.meisaiOrder) { return 0 }
        return -1
      }).sort((a, b) => {
        if (a.unkoJissekiNo > b.unkoJissekiNo) { return 1 }
        if (a.unkoJissekiNo === b.unkoJissekiNo) { return 0 }
        return -1
      }).sort((a, b) => {
        if (a.unkoYmd > b.unkoYmd) { return 1 }
        if (a.unkoYmd === b.unkoYmd) { return 0 }
        return -1
      })
    }
  },
  methods: {
  }
}
